import { Header, Icon, Label } from "semantic-ui-react";

const SegmentHeader = ({ title, icon, labelCount }) => {
  return (
    <div className="p-16 border border-neutral-20 rounded-4 bg-neutral-10 overflow-hidden">
      <Header as="h3" floated="left" className="is-bottom-margined-none">
        <Icon
          name={icon}
          color="blue"
          circular
          inverted
          style={{ fontSize: "0.8em" }}
        />
        <Header.Content>{title}</Header.Content>
      </Header>
      <Label circular basic color="grey" style={{ float: "right" }}>
        {labelCount}
      </Label>
    </div>
  );
};

export default SegmentHeader;
